export default __webpack_public_path__ + "static/media/circle-dot.1708af9d.svg";